<template>
  <a-form :form="form" @submit="handleSubmit">
    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">Nome</label>
          <a-input
            v-decorator="[
              `name`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            formErrors
          />
        </a-form-item>
      </a-col>

      <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">Cognome</label>
          <a-input
            v-decorator="[
              `surname`,
              { rules: [{ required: true, message: 'E\' un campo obbligatorio' }] }
            ]"
            formErrors
          />
        </a-form-item>
      </a-col>
    </a-row>

    <a-row :gutter="16">
      <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
        <a-form-item>
          <label class="font-bold" slot="label">Indirizzo email</label>

          <a-input
            html-type="email"
            v-decorator="[
              'email',
              {
                rules: [
                  { required: true, message: $t('msg.required') },
                  { type: 'email', message: $t('msg.requiredemail') }
                ]
              }
            ]"
          />
        </a-form-item>
      </a-col>
      <a-col :xs="{ span: 24 }" :sm="{ span: 12 }">
        <a-form-item :colon="false">
          <label class="font-bold" slot="label">Telefono</label>
          <a-input
            v-decorator="[
              'phone',
              {
                rules: [
                  {
                    type: 'string',
                    required: false,
                    pattern: /^[+]*[(]{0,1}[0-9]{0,4}[)]{0,1}[-\s\./0-9]*$/,
                    message: $t('msg.requiredphone')
                  }
                ]
              }
            ]"
          ></a-input>
        </a-form-item>
      </a-col>
    </a-row>
    <h2 class="mt-3 mb-4 text-lg text-center">Informativa Privacy</h2>
    <a-row :gutter="16">
      <a-col :xs="24" class="text-justify">
        <a-form-item :colon="false" class="pt-0 pb-1 my-0">
          <a-checkbox
            v-decorator="[
              'grant_privacy_insurance_policy',
              {
                validateTrigger: 'blur',
                valuePropName: 'checked',
                initialValue: false,
                rules: [
                  {
                    required: true,
                    message: $t('msg.required'),
                    transform: value => value || undefined, // Those two lines
                    type: 'boolean' // Do the magic
                  }
                ]
              }
            ]"
          >
            <span class="text-xs">
              Dichiaro di aver preso visione dell'
              <a href="/privacy-policy/" target="_blank" class="font-bold text-i4m-orange">
                informativa privacy
              </a>
              e di prestare il consenso per la comunicazione dei dati personali con le modalità
              indicate al PUNTO 1 per le finalità di stipula di polizze assicurative, la
              comunicazione dei dati personali agli altri soggetti competenti indicati al PUNTO 4
              per lo svolgimento degli obblighi normativi previstie di aver preso visione ed
              accettare il contenuto dei
              <a href="/terms-and-conditions/" target="_blank" class="font-bold text-i4m-orange">
                Termini e condizioni
              </a>
              <span class="font-bold text-i4m-orange">*</span>
            </span>
          </a-checkbox>
        </a-form-item>
        <a-form-item :colon="false" class="pb-4 mt-4 mb-0">
          <a-checkbox
            v-decorator="[
              'grant_privacy_marketing',
              {
                validateTrigger: 'blur',
                valuePropName: 'checked',
                initialValue: false
              }
            ]"
          >
            <span class="text-xs">
              Dichiaro di aver preso visione dell'
              <a href="/privacy-policy/" target="_blank" class="font-bold text-i4m-orange">
                informativa privacy
              </a>
              e di prestare il consenso per la comunicazione dei dati personali con le modalità
              indicate al PUNTO 1 per finalità di marketing
            </span>
          </a-checkbox>
        </a-form-item>
      </a-col>
    </a-row>

    <div class="flex justify-end w-full mt-4">
      <a-button type="primary" @click="handleSubmit" :loading="submitting">
        Salva
      </a-button>
    </div>
  </a-form>
</template>

<script>
import api from '@/api.js';

export default {
  name: 'contact-info-form',

  data() {
    return {
      form: this.$form.createForm(this, { name: 'customer-basic-info' }),
      submitting: false
    };
  },

  methods: {
    notificateError() {
      this.$notification.error({
        message: 'Ci sono errori nei dati forniti. Controlla e riprova',
        duration: 5
      });
    },

    handleSubmit() {
      this.submitting = true;

      this.form.validateFieldsAndScroll(
        { scroll: { offsetTop: 30, alignWithTop: true } },
        async (err, values) => {
          if (err) {
            console.log('Form is invalid: ', values);
            this.notificateError();
            this.submitting = false;
            return;
          }

          try {
            await api.addCustomer(values);
            await this.$store.dispatch('getOrder', true);

            this.submitting = false;
          } catch (err) {
            this.submitting = false;
            switch (err.response.status) {
              case 422:
                this.notificateError();
                let errors = err.response.data.errors;
                for (let field in errors) {
                  this.form.setFields({
                    [field]: { errors: [new Error(errors[field][0])] }
                  });
                }

                this.submitting = false;
                break;
              default:
                console.error(err);
                this.$notification.error({
                  message: "Anomalia nell'inserimento dati. Contattare l'assitenza",
                  duration: 5
                });
                break;
            }
          }
        }
      );
    }
  }
};
</script>

<style lang="scss">
.ant-checkbox .ant-checkbox-inner {
  height: 1.5rem;
  width: 1.5rem;
}
.ant-checkbox-inner::after {
  top: 40%;
  left: 15%;
  width: 10px;
  height: 18px;
}
.ant-form-item-control {
  line-height: 1.6rem;
}
</style>
